import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { NavController, LoadingController, ToastController } from '@ionic/angular';
import { AccountService } from 'src/app/api/account.service';
import { AppSettings } from 'src/app/app-settings';

const PasswordValidator: ValidatorFn = (fg: FormGroup) => {
  const password1 = fg.get('newPassword1').value;
  const password2 = fg.get('newPassword2').value;
  return !!password1 && !!password2 && password1 !== password2
    ?  { 'passwordDifference': true }
    : null;
};

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit {

  public passwordForm: FormGroup; 

  oldPasswordType: string = 'password';
  oldPasswordIcon: string = 'eye-off';
  newPassword1Type: string = 'password';
  newPassword1Icon: string = 'eye-off';
  newPassword2Type: string = 'password';
  newPassword2Icon: string = 'eye-off';
  
  isWeb = AppSettings.IS_WEB;

  constructor(private navController: NavController, private accountService: AccountService, private formBuilder: FormBuilder, private loadingCtrl: LoadingController, private toastCtrl: ToastController) { }

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      'oldPassword': [null, Validators.compose([
        Validators.required,
        Validators.maxLength(128),
      ])],
      'newPassword1': [null, Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(128),
      ])],
      'newPassword2': [null, Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(128)
      ])],
    }, {validator: PasswordValidator});
  }

  async save() {
    let loader = await this.loadingCtrl.create({
      message: 'Updating...'
    })

    loader.present();

    this.accountService.changePassword(this.passwordForm.get('oldPassword').value, this.passwordForm.get('newPassword1').value, this.passwordForm.get('newPassword2').value)
    .then(async () => {
      loader.dismiss();

      let toast = await this.toastCtrl.create({
        message: 'Password successfully updated',
        duration: 3000,
        showCloseButton: true,
        position: 'bottom',
        color: 'light',
      })

      toast.present().then(() => {
        this.goToProfile();
      })
    })
    .catch(async (error) => {

      if (error.status !== 0) {
        let errorMessage = "";

        Object.keys(error.error).forEach(key => {
          errorMessage += key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ") + " : ";
          error.error[key].forEach(err => {
            errorMessage += err
          });
        });

        loader.dismiss();

        let toast = await this.toastCtrl.create({
          message: errorMessage,
          duration: 3000,
          showCloseButton: true,
          position: 'bottom',
          color: 'light',
        })

        toast.present();
      }
    })
  }


  goToProfile() {
    this.navController.navigateBack("/tabs/tab4");
  }

  getPassword1() {
    return this.passwordForm.get('newPassword1').value;
  }

  public passwordCheck(form: FormControl): { [key: string]: any } {
    let errors = {};
    if (form.value !== null && (form.value + "").length > 128) {
      errors['length'] = (form.value + "").length;
    }

    if (errors !== {}) {
      return errors;
    }
    
    return null;
  }

  
  hideShowOldPassword() {
    this.oldPasswordType = this.oldPasswordType === 'text' ? 'password' : 'text';
    this.oldPasswordIcon = this.oldPasswordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  hideShowNewPassword1() {
    this.newPassword1Type = this.newPassword1Type === 'text' ? 'password' : 'text';
    this.newPassword1Icon = this.newPassword1Icon === 'eye-off' ? 'eye' : 'eye-off';
  }

  hideShowNewPassword2() {
    this.newPassword2Type = this.newPassword2Type === 'text' ? 'password' : 'text';
    this.newPassword2Icon = this.newPassword2Icon === 'eye-off' ? 'eye' : 'eye-off';
  }
}
